import Dexie from "dexie";
import db from "../Db";

var UpdateDefunt = Dexie.async(function* (DEFUNT) {
  yield db.open();
  yield db.DEFUNT.put(DEFUNT);
});

export default UpdateDefunt;
